import { Component } from '@angular/core';

/**
 * End User License Agreement, served at /terms.
 *
 * Public and unlinked by design — it exists so the URL can be given to
 * third parties (Intuit's app review requires an EULA URL) and read by anyone
 * without signing in.
 */
@Component({
  selector: 'bhub-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  standalone: false
})
export class TermsOfServiceComponent {
  /** Shown in the header and in the "last updated" line. */
  readonly effectiveDate = 'September 3, 2026';
}
